<template>
  <div class="lotos">
    <section>
      <div class="movie-area">
        <figure class="image is-1by2"> 
          <video id="movie" autoplay preload muted> 
              <source src="../assets/lotos.mp4" type="video/mp4">
              您的瀏覽器不支援HTML 5影片播放標籤格式。
              Your browser does not support the video tag.
          </video>
        </figure>
        <div id="moreBtn" v-on:click="scrollToContent">
        	<img src="../assets/more.svg" class="txt">
        	<img src="../assets/arrowMore.svg" class="arrow" v-bind:style="{marginTop: topValue + 'px'}">
        </div>
      </div>
    </section>
    <section class="section main-content">
      <div class="container">
        <div class="what-is-lotos columns boxed">
          <div class="column is-9">
            <h3 class="title"><span class="icon"><i class="fa fa-lightbulb-o" aria-hidden="true"></i></span>什麼是樂土材料？</h3>
            <p>樂土是由國立成功大學土木系「輕質與結構材料試驗室」的專業研發團隊，歷經多年研發出「水庫淤泥再生改質技術」專利環保防水材料。樂土擁有極為特殊分子結構，透過疏導透氣代替傳統防堵模式，讓建材兼顧防水透氣強大功能，不管是正負水壓的狀況均能處理，適用於各種建物的多元防水需求。</p>
            <p>同時材料本質穩定長久，完全針對台灣潮濕氣候設計，有效克服台灣建物防水難題。使用樂土的房屋，就如同穿上戶外機能性的GORE-TEX科技布料一般，讓建物具備透氣呼吸功效，強化防水/防潮效果且大幅提升您的居住品質。</p>
          </div>
          <div class="column">
            <figure class="image is-1by1">
              <img src="../assets/lotoslogo.png">
            </figure>
          </div>
        </div>
        <div class="how-lotos-work columns boxed">
          <div class="column is-7">
            <h3 class="title"><span class="icon"><i class="fa fa-lightbulb-o" aria-hidden="true"></i></span>樂土的運作原理</h3>
            <p>樂土的防水微粒，是來自水庫淤泥進行科技材料改質，擁有微米接近奈米等級的極細結構。具有物理斥水效果。加入水泥砂漿攪拌均勻後，每平方公尺水泥砂漿含有一億個斥水微粒，樂土斥水微粒能將任何水滴阻擋於外，卻仍保留水泥砂漿透氣度與毛孔作用，達到防水透氣效果！以疏導代替防堵解決以往建築難解之防水難題。</p>
          </div>
          <div class="column">
            <figure class="image is-2by1">
              <img src="../assets/lotosworks2.png">
            </figure>
          </div>
        </div>
        <div class="lotos-good columns boxed">
          <div class="column">
            <h3 class="title"><span class="icon"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i></span>材料優點</h3>
            <ul>
              <li class="anti"><p>將無機質防水材料，以樂土斥水特性透過物理反應將砂漿轉化為防水層，卻仍不會破壞砂漿性質！</p></li>
              <li class="beauty"><p>樂土提升建築外觀美感。經專業測試可抵抗三十米正負水壓。兼具防水防潮，抗白華預防壁癌等效果。</p></li>
              <li class="air"><p>保留透氣性，不阻塞材質自然孔隙讓建物擁有絕佳的防水性，更能保有仿呼吸性能，不讓水氣滯留於結構內。</p></li>
              <li class="weather"><p>添加樂土的砂漿，對於熱漲冷縮造成的微小裂縫不會影響防水性，再極端變化環境中，仍保有良好適應性。</p></li>
              <li class="longterm"><p>樂土是非常安定的無機質，在施作後結構可持續保持防水效能50年以上而且不受風吹日曬雨淋而退化。</p></li>
              <li class="cheap"><p>無須多餘工種，降低現場管理成本。每平方公尺施工成本不到55元，遠低於其他防水材料。</p></li>
            </ul>
          </div>
        </div>
        <div class="lotos-app columns boxed">
          <div class="column is-8">
            <h3 class="title"><span class="icon"><i class="fa fa-wrench" aria-hidden="true"></i></span>聰明防水工法</h3>
            <ul class="first">
                <li><p>老舊建物垂流面外牆防水失效，不須外部重新施作防水，只需內部砂漿添加樂土防水粉抹壁，即可解決內部壁癌問題。</p></li>
                <li><p>建築室內牆壁 地下室 浴室 磁磚及窗框防水工程。</p></li>
                <li><p>各種防水 防潮抗白華及預防壁癌的防治處理。</p></li>
            </ul>
            <div class="columns">
              <article class="message column">
                <div class="message-header">
                  <p>實作範例</p>
                </div>
                <div class="message-body">
                  <ol class="second column">
                    <li><p>外牆：樂土防水透氣砂漿水泥粉刷打底</p></li>
                    <li><p>室內牆：採用樂土防水透氣水泥粉刷打底粉光</p></li>
                    <li><p>建築外牆：維持原來砌磚不施作水泥粉刷</p></li>
                  </ol>
                </div>
              </article>

            </div>
          </div>
          <div class="column">
            <figure class="image is-1by1">
              <img src="../assets/smarthouse2.png">
            </figure>
          </div>
        </div>
        <div class="lotos-reporting boxed">
          <h3 class="title"><span class="icon"><i class="fa fa-newspaper-o" aria-hidden="true"></i></span>媒體報導</h3>
          <div class="columns">
            <div class="column">
              <div class=" video-container">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/EpnjdLnfdrA?rel=0&amp;showinfo=0" frameborder="0" allowfullscreen></iframe>
              </div>
            </div>
            <div class="column">
              <div class=" video-container">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/vbNPsmuiC84?rel=0&amp;showinfo=0" frameborder="0" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'lotos',
  data: function() {
    return {
      topValue: 0
    }
  },
  methods: {
    scrollToContent: function() {
      var main = document.getElementsByClassName('main-content')[0];
      function scrollToElement(element) {
        var el = element;
        var yPos = el.getClientRects()[0].top;
        var yScroll = window.scrollY;
        var i = 1;
        var interval = setInterval(function() {
          yScroll += 10;
          i++
          if (i== 500)
            clearInterval(interval);

          window.scroll(0, yScroll);
          if (el.getClientRects()[0].top < 0) {
            clearInterval(interval);
          }
        }, 5);
      }
      scrollToElement(main);
    }
  },
  beforeMount() {
      var self = this;
      setInterval(getTop,100)
      var status = true;
      function getTop() {     
        if (status) {
          self.topValue++
          if (self.topValue == 5) {
            status = false;
          }
        } else {
          self.topValue--
          if (self.topValue == 0) {
            status = true;
          }
        }
      }    
      getTop()
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '../mq'
.boxed
  margin-bottom: 4rem
  p 
    font-size: 1.2rem
    +mobile
      font-size: 1rem
  .title
    color: #399
  .title + p
    margin-bottom: 1rem
.how-lotos-work
  -webkit-flex-direction: row-reverse
  flex-direction: row-reverse
  .image
    img
      +desktop
        top: -55px
#movie 
  width: 100%
  height: auto

.icon 
  margin-right: 10px
.movie-area
  #moreBtn
    position: absolute
    bottom: 10px
    left: 50%
    cursor: pointer
    width: 53px
    height: 60px
    transform: translate(-50%,-0%)
    z-index: 1000
    +mobile
      display: none
    .arrow
      top: 20px
      left: 3px
  #moreBtn:hover
    opacity: 0.5
.lotos-good
  ul
    display: flex
    flex-flow: row wrap
    li
      flex: 50%
      line-height: 1.5
      padding: 0 1rem 2.5rem 90px
      +mobile
        flex: 100%
    .anti
      background: url('../assets/icon/icon_antiwater.png') no-repeat top left
    .beauty
      background: url('../assets/icon/icon_beauty.png') no-repeat top left
    .air
      background: url('../assets/icon/icon_air.png') no-repeat top left
    .weather
      background: url('../assets/icon/icon_weather.png') no-repeat top left
    .longterm
      background: url('../assets/icon/icon_longterm.png') no-repeat top left
    .cheap
      background: url('../assets/icon/icon_cheap.png') no-repeat top left

.lotos-app
  ul.first
    list-style-type: trad-chinese-formal
    padding: 0 2rem
    margin-bottom: 2rem
    li
      margin-bottom: 1rem
  .message-body
    padding: 0 1.25rem
  ol.second
    li
      margin-bottom: 1rem
.lotos-reporting
  .video-container
    position: relative
    padding-bottom: 56.25%
    padding-top: 30px
    height: 0
    overflow: hidden
    iframe
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
</style>


// WEBPACK FOOTER //
// src/components/Lotos.vue